import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-owl-carousel2/src/owl.carousel.css";
//Custom Components
import "../assets/scss/App.scss";
import Home from "../pages/home";
import Header from "../components/Layout/Header";
import About from "../pages/about";
import Blog from "../pages/blog";
import BlogDetails from "../pages/blog/blog-details";
import Services from "../pages/service";
import ServiceDetails from "../pages/service/service-details";
import Contact from "../pages/contact";
import Error from "../pages/404";
import LoadTop from "../components/Common/ScrollTop/LoadTop";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector} from "react-redux";
import {
  setBanner,
  setPage,
  setService,
  setTeam,
  setTestimonial,
  setProducts,
  setsiteSetting,
} from "../store/slice";
import Loader from "../Loader";
import axios from "axios";
import { BASE_URL } from "../../../Service";
import Maintenance from "../../../maintenancePage/maintenance";

// import Team from "../pages/team";
// import TeamDetails from "../pages/team/team-details";

const App = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [isMaintenance, setIsMaintenance] = useState(false);
  const domains = useSelector((state) => state.data.domains);


  
  // useEffect(() => {
  //   const headers = {
  //     "Content-Type": "application/json",
  //     domain: "techniajz.com",
  //   };

  //   const fetchSiteSetting = async () => {
  //     try {
  //       const siteSettingRes = await axios.get(
  //         `${BASE_URL}/api/v1/siteSetting/get`,
  //         { headers }
  //       );

  //       if (siteSettingRes.data.success) {  
  //         const siteSetting =
  //         siteSettingRes?.data?.data?.siteSetting?.[0]?.data;
  //         const enableMaintenance = siteSetting?.enableMaintenance;


  //         if (enableMaintenance === true) {
  //           setIsMaintenance(true);
  //           setLoading(false);
  //           return;
  //         }

  //         dispatch(setsiteSetting(siteSettingRes.data.data));
  //       }
  //         const [
  //           bannerRes,
  //           pageRes,
  //           serviceRes,
  //           teamRes,
  //           testimonialRes,
  //           productRes,
  //         ] = await Promise.all([
  //           axios.get(`${BASE_URL}/api/v1/banner`, { headers }),
  //           axios.get(`${BASE_URL}/api/v1/page`, { headers }),
  //           axios.get(`${BASE_URL}/api/v1/service`, { headers }),
  //           axios.get(`${BASE_URL}/api/v1/team`, { headers }),
  //           axios.get(`${BASE_URL}/api/v1/testimonials`, { headers }),
  //           axios.get(`${BASE_URL}/api/v1/product`, { headers }),
  //         ]);

  //         if (bannerRes.data.success) dispatch(setBanner(bannerRes.data.data));
  //         if (pageRes.data.success) dispatch(setPage(pageRes.data));
  //         if (serviceRes.data.success)
  //           dispatch(setService(serviceRes.data.data));
  //         if (teamRes.data.success) dispatch(setTeam(teamRes.data.data));
  //         if (productRes.data.success)
  //           dispatch(setProducts(productRes.data.data));
  //         if (testimonialRes.data.success)
  //           dispatch(setTestimonial(testimonialRes.data.data));
        
  //     } catch (err) {
  //       console.error("Error fetching data:", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchSiteSetting();
  // }, [dispatch]);

  useEffect(() => {

      if (!domains || domains.length === 0) return;

      const searchParams = new URLSearchParams(window.location.search);
      const domain = searchParams.get("host") || window.location.hostname;
      const matchedDomain = domains.find((site) =>
        site.domainList.includes(domain)
      );

    if (!matchedDomain) {
      console.warn("No matching domain found for:", domain);
      setLoading(false);
      return;
    }
  const headers = {
    "Content-Type": "application/json",
    domain: domain,
  };

  const fetchSiteSetting = async () => {
    try {
      const siteSettingRes = await axios.get(
        `${BASE_URL}/api/v1/siteSetting/get`,
        { headers }
      );

      if (!siteSettingRes.data.success) {
        throw new Error("Site settings fetch unsuccessful");
      }

      const siteSetting =
        siteSettingRes?.data?.data?.siteSetting?.[0]?.data;
      const enableMaintenance = siteSetting?.enableMaintenance;

      if (enableMaintenance === true) {
        setIsMaintenance(true);
        return;
      }

      dispatch(setsiteSetting(siteSettingRes.data.data));

      // Fetch other Api
      const [
        bannerRes,
        pageRes,
        serviceRes,
        teamRes,
        testimonialRes,
        productRes,
      ] = await Promise.all([
        axios.get(`${BASE_URL}/api/v1/banner`, { headers }),
        axios.get(`${BASE_URL}/api/v1/page`, { headers }),
        axios.get(`${BASE_URL}/api/v1/service`, { headers }),
        axios.get(`${BASE_URL}/api/v1/team`, { headers }),
        axios.get(`${BASE_URL}/api/v1/testimonials`, { headers }),
        axios.get(`${BASE_URL}/api/v1/product`, { headers }),
      ]);

      // If any of the APIs return success: false, go into maintenance mode
      if (
        !bannerRes.data.success ||
        !pageRes.data.success ||
        !serviceRes.data.success ||
        !teamRes.data.success ||
        !testimonialRes.data.success ||
        !productRes.data.success
      ) {
        throw new Error("One or more API responses unsuccessful");
      }

      // Dispatch only if all are successful
      dispatch(setBanner(bannerRes.data.data));
      dispatch(setPage(pageRes.data));
      dispatch(setService(serviceRes.data.data));
      dispatch(setTeam(teamRes.data.data));
      dispatch(setProducts(productRes.data.data));
      dispatch(setTestimonial(testimonialRes.data.data));
    } catch (err) {
      console.error("Error in data fetch:", err);
      setIsMaintenance(true);
    } finally {
      setLoading(false);
    }
  };

  fetchSiteSetting();
}, [dispatch]);


  if (loading) {
    return <Loader />;
  }

  return (
    <div className="App">
      <Router>
        <LoadTop />
        {isMaintenance ? (
          <Switch>
            <Route path="*" component={Maintenance} />
          </Switch>
        ) : (
          <>
            <Header
              parentMenu="home"
              secondParentMenu="multipage"
              activeMenu=""
            />
            <Switch>
              <Route path="/" exact component={Home} />
              <Route path="/home" component={Home} />
              <Route path="/about" component={About} />
              <Route path="/service" exact component={Services} />
              <Route path="/service/:id" exact component={ServiceDetails} />
              <Route path="/blog" exact component={Blog} />
              <Route path="/blog/blog-details" component={BlogDetails} />
              <Route path="/contact" component={Contact} />
              <Route component={Error} />
            </Switch>
          </>
        )}
      </Router>
    </div>
  );
};

export default App;
